var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CButton',{directives:[{name:"c-tooltip",rawName:"v-c-tooltip.hover.click",value:({
    content: _vm.tooltipContent,
    placement: 'top',
  }),expression:"{\n    content: tooltipContent,\n    placement: 'top',\n  }",modifiers:{"hover":true,"click":true}}],staticClass:"clip",on:{"click":_vm.copyToClipboard,"mouseleave":_vm.handleMouseLeave}},[_c('CIcon',{attrs:{"name":"copy","size":"custom-size","height":19,"viewBox":"0 0 32 32"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }